<template>
    <div class="close-button px-rem1 py-rem1" @click="$emit('close')">
        <svg
            class="relative"
            :width="`32px`"
            :height="`32px`"
            :viewBox="`0 0 24 24`"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 5L19 19M5 19L19 5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </div>
</template>

<style scoped lang="scss">
.close-button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    will-change: opacity;
    filter: drop-shadow(2px 2px 16px theme('colors.pale-pink-400'))
        drop-shadow(2px 2px 32px theme('colors.pale-pink-400'));
}
</style>
